import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'meetingStatus',
})
export class MeetingStatusPipe implements PipeTransform {
  transform(status: any, type?: any): any {
    if (type === 'COLOR')
      switch (status) {
        case false:
          return 'warning';
        case true:
          return 'success';
      }
    if (type === 'TEXT')
      switch (status) {
        case true:
          return 'Completed';
        case false:
          return 'Planned';
      }
  }
}
